import React, { useState, useEffect } from 'react'
import NavBar from "./NavBar"
import Footer from './Footer'
import { FiMoreHorizontal } from 'react-icons/fi'
import { useDispatch, useSelector } from 'react-redux'
import { viewJobPost } from '../../../services/operations/JobPostAPI'
import Loader from '../../loader/Loader'
import { useSearchParams } from 'react-router-dom'

const JobDetailing = () => {
  const [jobId, setJobId] = useState('');
  const [job, setJob] = useState([]);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading)
  const baseCandidateUrl = process.env.REACT_APP_CANDIDATE_URL;

  useEffect(() => {
    const fetchJob = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const encodedJob = queryParams.get('job');

      if (encodedJob) {
        const decodedId = atob(decodeURIComponent(encodedJob));
        setJobId(decodedId);
        const result = await dispatch(viewJobPost("", decodedId));
        if (result?.data?.job) {
          setJob(result.data.job);
        }
      }
    };

    fetchJob();
  }, []);



  const skills = job.skills ? JSON.parse(job.skills) : [];
  const industries = job.industries ? JSON.parse(job.industries) : [];


  const handleApplyJob = (id) => {
    const applyUrl = `${baseCandidateUrl}?jobId=${id}`;
    window.open(applyUrl, "_blank");
  }



  return (
    <>
      <NavBar text={true}/>
      {loading && <Loader />}
      <div className='all-jobs-detailing-dashboard'>
        <div className='all-jobs-detailing-container'>
          <div className='all-jobs-first'>
            <div className='all-jobs-first-section-apply-part'>
              <p style={{ fontWeight: "600", fontSize: "20px" }}>{job.job_title}</p>
              <button className='job-listing-detail-apply-button' onClick={() => handleApplyJob(job.id)}>Apply Job</button>
            </div>

            <p style={{ fontSize: "16px" }}>{job.company_name}</p>
            <p style={{ color: " rgba(0, 0, 0, 0.5)", fontSize: "14px" }}>{job.job_location}</p>
          </div>
          <div className='jobpost-detail-first' style={{ marginTop: "15px" }}>
            <p className='jobpost-detail-work-type'>{job?.workplace_type}</p>
            <p className='jobpost-detail-work-type'>{job?.employment_type}</p>
          </div>
          <div style={{ marginTop: "20px", borderBottom: "0.5px solid rgba(0, 0, 0, 0.1)" }} />
          <div className='job-detailing-second-section'>
            <p style={{ fontWeight: "600", fontSize: "20px" }}>About the job</p>
            <p
              style={{
                all: "unset",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                fontSize: "13px",
                fontWeight: "400",
                lineHeight: "1.5",
              }}
              dangerouslySetInnerHTML={{ __html: job.description }}
            ></p>
            <p style={{ fontWeight: "600", fontSize: "20px", marginTop: '20px' }}>Skills required</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {skills?.length > 0 && (
                skills.map((skill, index) => (
                  <span
                    key={index}
                    style={{
                      background: 'white',
                      padding: '5px 10px',
                      borderRadius: '20px',
                      fontSize: '14px',
                      border: "0.5px solid rgba(45, 118, 253, 1)",
                      color: "rgba(45, 118, 253, 1)"
                    }}
                  >
                    {skill}
                  </span>
                )))}
            </div>
            <p style={{ fontWeight: "600", fontSize: "20px", marginTop: '20px' }}>Industries</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {industries?.length > 0 && (
                industries.map((industry, index) => (
                  <span
                    key={index}
                    style={{
                      background: 'white',
                      padding: '5px 10px',
                      borderRadius: '20px',
                      fontSize: '14px',
                      border: "0.5px solid rgba(45, 118, 253, 1)",
                      color: "rgba(45, 118, 253, 1)"
                    }}
                  >
                    {industry}
                  </span>
                )))}
            </div>
            {/* {job?.experience && (<>
              <p style={{ fontWeight: "600", fontSize: "20px", marginTop: '20px' }}>Experience Required</p>
              <p style={{ fontSize: "16px" }}>
               {job?.experience && job.experience !== "N/A"
                      ? `${job.experience} Years`
                      : "N/A"}
                </p></>)} */}
            {job?.experience && (() => {
              let parsed;

              try {
                if (typeof job.experience === "string") {
                  parsed = JSON.parse(job.experience);
                } else {
                  parsed = job.experience;
                }
              } catch (e) {
                parsed = job.experience; 
              }

              const expDisplay = Array.isArray(parsed) ? parsed.join(", ") : parsed;

              return (
                <>
                  <p style={{ fontWeight: "600", fontSize: "22px", marginTop: '20px' }}>
                    Experience Required
                  </p>
                  <p style={{ fontSize: "18px" }}>{expDisplay} Years</p>
                </>
              );
            })()}
            {job?.salary_range && (
              <> <p style={{ fontWeight: "600", fontSize: "20px", marginTop: '20px' }}>Expected Salary</p>
                <p style={{ fontSize: "16px" }}>{job?.salary_range}</p>
              </>
            )}
            {
              job?.contract_price_per_hrs && (
                <>
                  <p style={{ fontWeight: "600", fontSize: "20px", marginTop: '20px' }}>Contract Pay</p>
                  <p style={{ fontSize: "16px" }}>
                    {job?.contract_price_per_hrs && job.contract_price_per_hrs !== "N/A"
                      ? `$${job.contract_price_per_hrs}/hr`
                      : "N/A"}
                  </p>
                </>)
            }
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default JobDetailing